module.exports = __webpack_public_path__ + "static/media/empty-state-illustration@3x.46d2a9f0.png";